<template>
	<header>
		<nav class="navbar navbar-default app-head">
			<div class="navbar-header">
        <!--<a class="navbar-brand" href="/index"><img src="../../assets/inner-logo_.png" alt="首页"></a>-->
        <a class="navbar-brand" href="/index"><img src="../../assets/inner-logo.png" alt="首页"></a>
				<span v-if="isProd" style="color: yellow;line-height: 55px;font-size: 20px;">已连接正式服务器！！！</span>
			</div>
            <div class="right">
                <span class="info">{{roleId|parseRoleType}}：{{roleName}} - ( {{userId}} )</span>
                <div class="btns">
                    <span class="_btn" @click="toSupervisor">前往监管系统</span>
                    <span class="_btn" v-if="mulRole == true" @click="switchRole">切换用户</span>
                </div>
                <span class="_btn out" @click="logout">安全退出</span>
            </div>
		</nav>
	</header>
</template>
<script>
import { API_CONST, API_Common } from "@/api/api.js"
import openByPost from "@/tool/openByPost.js"
import { base } from "@/api/config.api.js"

export default {
	data() {
		return {
			roleId: "",
			userId: "",
			roleName: "",
			mulRole: "",
			isProd:false,
		};
	},
	mounted(){
		let userinfo = JSON.parse(localStorage.getItem("userinfo"));
		this.roleId = userinfo.roleId;
		this.userId = userinfo.userId;
		this.roleName = userinfo.roleName;
		this.mulRole = userinfo.mulRole;
		// console.log(localStorage.getItem("userinfo"));
		if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
			if(base == "http://www.hmzan.com/rest"){
				this.isProd = true;
			}else{
				this.isProd = false;
			}
		}
	},
	methods: {
		toSupervisor() {
			// 前往监管系统
			let nowtime = new Date().getTime();
			let text = this.userId + nowtime + "nova2275337!@#";
			API_Common.getMD5(encodeURIComponent(text)).then(res => {
				let json = {
					"_eosFlowAction": "login",
					"param/novaUserid": this.userId,
					"param/novaNowtime": nowtime,
					"param/novaMenuid": "",
					"param/novaCiphertext": res //MD5
				}
				openByPost(API_CONST.originalAdress, json);
				return false;
			});

		},
		switchRole() {
			this.$router.replace({ path: '/switchRole', query: { cango: true } })
		},
		logout() {
			this.$router.replace('/logout')
		}
	},
	filters: {
		parseRoleType(roleId) {
			let type = "";
			switch (roleId) {
				case "UnitPerson":
					type = "建设单位负责人";
					break;
				case "SupervisionUnit":
					type = "监理单位";
					break;
				case "SE":
					type = "总监理工程师";
					break;
				case "pm":
					type = "项目经理";
					break;
				case "BuildUnit":
					type = "施工单位";
					break;
				case "admin":
					type = "系统管理员";
					break;
				case "unit":
					type = "建设单位";
					break;
			}
			return type;
		}
	}
};
</script>
<style>
header {
	position: absolute;
	top: 0;
	z-index: 3;
	height: 65px;
	width: 100%;
    font-family: 微软雅黑;
}

nav.app-head {
	margin: 0;
	width: 100%;
	background-color: #3589f0;
	border-color: #3589f0;
	border-radius: 0;
	height: 100%;
}

nav.app-head>.container-fluid {
	padding: 0;
}

nav .navbar-brand{
    padding: 0px;
    padding-left: 13px;
    margin-top: 9px;
    /*margin-top: 13px;*/
    height: auto;
}
nav.navbar{
    border: none!important;
}
nav .right{
    color: #fff;
    float: right;
    line-height: 63px;
    margin-right: 16px;
}
nav .info{
    font-size: 14px;
}
nav .info:after{
    content: '|';
    color: #5da1f3;
    margin-left: 20px;
    font-size: 12px;
}
nav ._btn{
    display: inline-block;
    width: 120px;
    height: 32px;
    line-height: 32px;
    background-color: #5aa4ff;
    font-size: 14px;
    border-radius: 30px;
    margin-left: 15px;
    cursor: pointer;
    text-align: center;
}
nav ._btn:hover,nav .btn:active{
    color: #5aa4ff;
    background-color: #fff;
    list-style: none;
}
nav .btns{
    display: inline-block;
}
@media screen and (max-width: 1320px) {
    nav ._btn{
        width: 90px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
    }
}
</style>




// WEBPACK FOOTER //
// app_head.vue?a6237792